export default function NumberInput({
  value,
  onChange,
  min = 0,
  max = Infinity,
  className = "",
  disabled = false,
  hasError = false,
}) {
  // Matches the red border plain inputs get when invalid, so a stepper field
  // that fails validation is as obvious as a text field that does.
  const borderColor = hasError ? "border-red-400" : "border-gray-300";
  // Treat a blank/NaN value as the floor so the steppers still bound correctly.
  const numericValue = Number.isNaN(parseInt(value)) ? min : parseInt(value);
  const atMax = numericValue >= max;
  const atMin = numericValue <= min;

  const handleIncrement = () => {
    if (disabled || atMax) return;
    const newValue = Math.min(numericValue + 1, max);
    onChange(newValue.toString());
  };

  const handleDecrement = () => {
    if (disabled || atMin) return;
    const newValue = Math.max(numericValue - 1, min);
    onChange(newValue.toString());
  };

  return (
    <div className={`flex items-center ${className}`}>
      <button
        type="button"
        onClick={handleDecrement}
        disabled={disabled || atMin}
        className={`p-2 rounded-l-md border border-r-0 ${borderColor} bg-gray-50 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-gray-50`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-5 text-gray-600"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </svg>
      </button>
      <input
        type="text"
        value={value}
        disabled
        className={`block w-full text-center ${borderColor} shadow-xs focus:border-indigo-500 focus:ring-indigo-500`}
      />
      <button
        type="button"
        onClick={handleIncrement}
        disabled={disabled || atMax}
        className={`p-2 rounded-r-md border border-l-0 ${borderColor} bg-gray-50 hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-gray-50`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-5 text-gray-600"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
            clipRule="evenodd"
          />
        </svg>
      </button>
    </div>
  );
}
